import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid')
import { Form, Button } from 'react-bootstrap';
const filter = require('lodash/filter');
const find = require('lodash/find');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const TemplateStore = require('../../stores/template_store_reflux');
const TemplatePermissionStore = require('../../stores/TemplatePermissionStore');
const TemplatePermissionActions = require('../../actions/TemplatePermissionActions');
import LoadingMainContent from '../loading/LoadingMainContent';

const propTypes = {
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string ]),
        type: PropTypes.oneOf(Object.values(Globals.users.type)),
    }).isRequired
};

const defaultProps = {};

class AdminUserTemplatePermissionsEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            templateStoreState: TemplateStore.getState(),
            userPermissions: TemplatePermissionStore.getState().permissions[this.props.user.id] || [],
            selectedNewPermission: '',
            actionId: null
        };

        this.getDataForUserId = this.getDataForUserId.bind(this);
        this.onSelectNewPermission = this.onSelectNewPermission.bind(this);
        this.onAddTemplatePermission = this.onAddTemplatePermission.bind(this);
        this.unsubscribes = [
            TemplateStore.listen(this.onStoreChange.bind(this, 'templateStoreState')),
            TemplatePermissionStore.listen(this.onTemplatePermissionStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        this.getDataForUserId(this.props.user.id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.id !== this.props.user.id) {
            this.getDataForUserId(this.props.user.id);
        }

    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getDataForUserId(userId) {
        TemplatePermissionActions.getUserTemplatePermissions(uuid.v4(), { userId: userId });
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    onTemplatePermissionStoreChange(state) {
        this.setState({
            userPermissions: state.permissions[this.props.user.id] || [],
        });
    }

    onSelectNewPermission(e) {
        this.setState({ selectedNewPermission: e.target.value });
    }

    onAddTemplatePermission() {
        if (!this.state.selectedNewPermission) {
            return;
        }

        const actionId = uuid.v4();
        this.setState({ actionId: actionId }, () => {
            TemplatePermissionActions.addTemplatePermission(actionId, {
                userId: this.props.user.id,
                templateId: this.state.selectedNewPermission
            });
        });
    }

    render() {
        if (!this.state.templateStoreState.initialized) {
            return <LoadingMainContent />;
        }

        if (this.props.user.type !== Globals.users.type.LOCAL) {
            return (
                <div>
                    Unavailable for this user type.
                </div>
            );
        }

        const filteredPerms = filter(this.state.userPermissions, perm => !perm.public);
        const templateOptions = filter(this.state.templateStoreState.globalTemplates, (tmpl) => {
                return !tmpl.public && !find(this.state.userPermissions, perm => perm.id == tmpl.id);
            });
        return (
            <div>
                <div className="permissions-list">
                    {(filteredPerms.length) > 0 ?
                        <ul>
                            {filteredPerms.map((perm) => 
                                <li key={perm.id}>{perm.name}</li>
                            )}
                        </ul>
                        :
                        Strings['en'].common.NONE
                    }
                </div>

                <Form>
                    <Form.Group controlId="formControlsSelectMultiple">
                        <Form.Label>Add New Permissions</Form.Label>
                        <Form.Control
                            as="select"
                            placeholder="select"
                            value={this.state.selectedNewPermission}
                            onChange={this.onSelectNewPermission}
                        >
                            <option value="select">{templateOptions.length > 0 ? 'Select a template...' : Strings['en'].common.NONE}</option>
                            {templateOptions.map((tmpl) =>
                                <option key={tmpl.id} value={tmpl.id}>{tmpl.name}</option>
                            )}
                      </Form.Control>
                    </Form.Group>

                    <Button
                        onClick={this.onAddTemplatePermission}
                        disabled={!this.state.selectedNewPermission}
                    >
                        Add Permission
                    </Button>
                </Form>
            </div>
        );
    }
}

AdminUserTemplatePermissionsEditor.propTypes = propTypes;
AdminUserTemplatePermissionsEditor.defaultProps = defaultProps;

export default AdminUserTemplatePermissionsEditor;